<template>
  <div class="pb-color-icon">
    <PieChart
      class="pb-color-icon-pie"
      :sectors="sectors"
      :offset="offset"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Color } from '@nicolaudie-group/ls-utilities'
import asArray from '@nicolaudie-group/ng-ui-kit/helpers/asArray'
import * as colorHelpers from '@nicolaudie-group/ng-ui-kit/helpers/color'

import PieChart from '@/components/PieChart.vue'

const props = defineProps({
  /**
   * Colors in the icon
   */
  value: { type: [Array, String, Number, Color], default: () => new Color('#fff') },
})

const colors = computed(() => {
  // Normalize colors to an array of colors
  const colorsArray = asArray(props.value)
  // Parse each color, that will be casted to a string
  return colorsArray.map(colorHelpers.parseColor)
})

const sectorSize = computed(() => 1 / colors.value.length)
const offset = computed(() => {
  switch (colors.value.length) {
    case 2:
      // Offset by 225° (62.5%) if 2 colors, so that it looks nicer and the first color is on top
      return 225 / 360
    case 4:
      // Offset by 315° (87.5%) if 4 colors, so that it looks nicer and the first color is on top
      return 315 / 360
    default:
      return 0
  }
})
const sectors = computed(
  () => colors.value.map(
    (color) => ({
      color: color.isValid ? color.hex : '#ffffff',
      size: sectorSize.value,
    }),
  ),
)
</script>

<style lang="scss" src="./ColorIcon.scss" />
